import {
  Box,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  MenuItem,
  Select,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { axiosInstance } from "../../services/api/api";
import { useEffect, useState } from "react";

// svg
import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import { usePlannerContext } from "../../services/context/planner-context";
import { TooltipWithIconCustom } from "./tooltip-custom";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    /*   boxShadow: theme.shadows[1],
     fontSize: 11 */
  },
}));

export const BasicSelect = ({
  value,
  setValue,
  name,
  label,
  unit,
  options,
  requier = false,
  placeholder = "",
  area,
  tooltip,
  disabled = false
}) => {
  /* const [value, setValue] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  }; */

  const { validateStart, setValidateEnd, setErrors } = usePlannerContext();
  
  const currentValue =
    value === null || value === undefined || value === -1 ? "" : value;

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorAPI, setErrorAPI] = useState(false);

  const updateBuilding = async (buildingId, buildingInputs) => {
    setLoading(true);
    setErrorAPI(null);
    try {
      const response = await axiosInstance.put(
        `/buildings/updateBuilding/${buildingId}`,
        buildingInputs
      );

    } catch (error) {
      // Handle error
      setErrorAPI(true);
    } finally {
      setLoading(false);
    }
  };

  const onChangeHandler = (e) => {
    const inputValue = e.target.value;
    const inputValueNum = inputValue !== "" ? Number(inputValue) : -1;

    if (area && area.buildingId && inputValueNum !== currentValue) {
      setValue(inputValueNum, name);
      setError(null)
      const buildingInputs = {
        ...area.building,
        [name]: inputValueNum,
      };

      updateBuilding(area.buildingId, buildingInputs);
    }
  };

  const reloadHandler = () => {
    const inputValueNum = currentValue !== "" ? Number(currentValue) : -1;

    if (area && area.buildingId) {
      const buildingInputs = {
        ...area.building,
        [name]: inputValueNum,
      };

      updateBuilding(area.buildingId, buildingInputs);
    }
  };

  useEffect(()=>{
    if(validateStart > 0){
      if(!!error || errorAPI){
        setErrors(prev => prev + 1);
      } else if(requier && currentValue === ''){
        setError('This field is required and cannot be empty.')
        setErrors(prev => prev + 1);
      }
      setValidateEnd(prev => prev + 1)
    }
  }, [validateStart])

  return (
    <FormControl
        error={!!error || errorAPI}
        /* variant="standard" */
        sx={{ width: "100%" }}
      >
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "4px",
          mb: "4px",
          padding: "0px 8px",
        }}
      >
        <TooltipWithIconCustom text={tooltip} >
        <Typography
           sx={{
            fontSize: "12px",
            color: "#343745",
            fontWeight: 500,
            lineHeight: 1.9,
          }}
          >
            {label} {unit && <span style={{ color: "#a2a3a3" }}>[{unit}]</span>}{" "}
            {requier && "*"}
          </Typography>
        </TooltipWithIconCustom>

        {loading && <CircularProgress size={15} />}
        {errorAPI && (
          <IconButton sx={{ padding: "4px" }} onClick={reloadHandler}>
            <IconReload stroke="#ba1a1a" width={"14px"} height={"14px"} />
          </IconButton>
        )}
      </Box>

      <Select
        /* MenuProps={{ disablePortal: false, anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          }, }} */
          disabled={disabled}
        value={currentValue}
        displayEmpty
        renderValue={() => {
          if (currentValue === "") {
            return (
              <Typography color="#e0e0e0" fontSize={"12px"} mt={"2px"}>
                {placeholder}
              </Typography>
            );
          }
          return value;
        }}
        name={name}
        onChange={onChangeHandler}
        size="small"
        className="nodrag nopan"
        sx={{
          fontSize: "14px",
          "& .MuiSelect-select": {
            padding: "8.5px 8px",
          },
          "&.MuiInputBase-root": {
            borderRadius: "8px",
            background: "#fff",
          },
          "&.MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#dbdbeb",
              borderWidth: "1px",
              transition: "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            },
            "&:hover fieldset": {
              borderColor: "#efa21e",
              borderWidth: "1px",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#efa21e",
              borderWidth: "1px",
            },
          },
        }}
      >
        {options.map((item) => (
          <MenuItem key={item} value={item} /* disabled={name === 'truckRequirement' && item !== 40} */>
            {item}
          </MenuItem>
        ))}
      </Select>
      {error && (
          <FormHelperText sx={{ pl: "8px", ml: 0, mr: 0  }} id="component-error-text">
            {error}
          </FormHelperText>
        )}
      {errorAPI && (
        <FormHelperText sx={{ pl: "8px", ml: 0, mr: 0 }} id="component-error-text">
          Failed to save the value. Please click the reload button (
          {<IconReload stroke="#ba1a1a" width={"10px"} height={"10px"} />})
          {/*  to
            try again. */}
        </FormHelperText>
      )}
    </Box>
      </FormControl>
    
  );
};
